class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.mega-menu__toggle');
    this.content = this.querySelector('.mega-menu__content');
    this.header = document.querySelector('.header-wrapper');

    this.toggle.addEventListener('click', this.onToggleClick.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onToggleClick() {
    if (this.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.close();
    this.toggle.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  open() {
    if (!this.animations) this.animations = this.content.getAnimations();
    this.setAttribute('open', '');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.content.removeAttribute('inert');
    this.animations.forEach((animation) => animation.play());

    if (this.header) {
      this.header.preventHide = true;
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  close() {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('inert', '');
    if (this.animations) this.animations.forEach((animation) => animation.cancel());
    if (this.header) this.header.preventHide = false;
  }
}

customElements.define('mega-menu', MegaMenu);
